import DeleteAccount from "components/Settings/DeleteAccount/index";
import BYOS from "containers/BYOS/index";
import { useState, useEffect, useRef } from "react";
import Modal from "components/Models/index";
import AdvancedSettings from "./AdvancedSettings";
import "./adminPage.scss";

const ThreeDotIcon = ({ onClick }) => (
    <svg
        onClick={onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="admin-mobile-action-icon"
    >
        <path
            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
            stroke="#667085"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
            stroke="#667085"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
            stroke="#667085"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

function Admin(
    { handleManage, handleManageTeam, handleManageRole, handleManageAdvanced, backendOperations = [] }
) {
    const [byosOn, setByosOn] = useState(false);
    const [updateOn, setUpdateOn] = useState(false);
    const [menuOpenId, setMenuOpenId] = useState(null);
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [descriptionContent, setDescriptionContent] = useState({ title: "", text: "" });
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpenId(null);
            }
        };
        if (menuOpenId) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpenId]);

    const handleBYOS = () => {
        setByosOn(true);
    };
    const handleUpdate = () => {
        setUpdateOn(true);
    };

    const toggleMenu = (e, id) => {
        e.stopPropagation();
        if (menuOpenId === id) {
            setMenuOpenId(null);
        } else {
            setMenuOpenId(id);
        }
    };

    const handleShowDescription = (title, text) => {
        setDescriptionContent({ title, text });
        setShowDescriptionModal(true);
        setMenuOpenId(null);
    };

    const userType = sessionStorage.getItem("usertype");
    const isEmployee = userType === "Employee";

    const adminSections = [
        // {
        //     id: "byos",
        //     title: "Bring your own Storage",
        //     description: "Change the storage location of encrypted files of your organization to your own cloud storage.",
        //     action: "Bring Your Own Storage",
        //     onClick: handleBYOS,
        //     hidden: isEmployee // Storage admin usually for SuperAdmin, hide for now or add perm check
        // },
        // {
        //     id: "update",
        //     title: "Update Storage Credentials",
        //     description: "Change the storage credentials without changing location of storage.",
        //     action: "Update Credentials",
        //     onClick: handleUpdate,
        //     hidden: isEmployee
        // },
        {
            id: "users",
            title: "Manage Your Users",
            description: "Keep your company account secure by managing who has access. Regularly review your user list and remove any inactive users.",
            action: "Manage Users",
            onClick: handleManage,
            hidden: isEmployee && !backendOperations.some(id => [9, 2].includes(id))
        },
        {
            id: "teams",
            title: "Manage Your Team",
            description: "Keep your company account secure by managing who has access. Regularly review your user list and remove any inactive users.",
            action: "Manage Teams",
            onClick: handleManageTeam,
            hidden: isEmployee && !backendOperations.some(id => [45, 80, 46, 47, 48].includes(id))
        },
        {
            id: "roles",
            title: "Manage Your Roles",
            description: "Keep your company account secure by managing who has access. Regularly review your user list and remove any inactive users.",
            action: "Manage Roles",
            onClick: handleManageRole,
            hidden: isEmployee && !backendOperations.some(id => [44, 81, 41, 42, 43].includes(id))
        },
        {
            id: "advanced-settings",
            title: "Advanced Settings",
            description: "Configure allowed/denied countries, regions, and file types for invited users.",
            action: "Advanced Settings",
            onClick: handleManageAdvanced,
            hidden: isEmployee && !backendOperations.some(id => [128, 129].includes(id))
        }
    ].filter(s => !s.hidden);

    const renderRows = (sections) => {
        return sections.map((section) => (
            <div
                className={`GeneralManage ${isMobile ? "mobile-row" : ""}`}
                key={section.id}
                onClick={isMobile ? section.onClick : undefined}
                style={isMobile ? { cursor: "pointer" } : {}}
            >
                <div className="Manage">
                    <h2>{section.title}</h2>
                    {!isMobile && <p className="admin-description">{section.description}</p>}
                </div>
                {!isMobile ? (
                    <span onClick={section.onClick} className="admin-action">{section.action}</span>
                ) : (
                    <div className="admin-mobile-action" style={{ position: "relative" }}>
                        <ThreeDotIcon onClick={(e) => toggleMenu(e, section.id)} />
                        {menuOpenId === section.id && (
                            <div className="admin-popup-menu" ref={menuRef}>
                                <div className="menu-item" onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowDescription(section.title, section.description);
                                }}>Description</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        ));
    };

    return (
        <>
            {updateOn == false && byosOn == false && <div className="admin" onClick={() => setMenuOpenId(null)}>
                {adminSections.some(s => s.id === "update") && (
                    <div className="storageDetails">
                        <h1>Storage Details</h1>
                        {renderRows(adminSections.filter(s => s.id === "update"))}
                    </div>
                )}

                <div className="userDetails">
                    <h1>Manage Organization</h1>
                    {renderRows(adminSections.filter(s =>
                        s.id === "users" ||
                        s.id === "teams" ||
                        s.id === "roles" ||
                        s.id === "advanced-settings"
                    ))}
                </div>

                {!isEmployee && (
                    <div className="deleteAccount">
                        <h1>Delete Account</h1>
                        <DeleteAccount hideDescription={isMobile} isMobile={isMobile} />
                    </div>
                )}
            </div>}

            {showDescriptionModal && (
                <Modal
                    heading="Description"
                    showFooter={false}
                    showHeader={true}
                    showCross={true}
                    closable={true}
                    handleCancel={() => setShowDescriptionModal(false)}
                >
                    <div className="admin-description-popup">
                        <p>{descriptionContent.text}</p>
                    </div>
                </Modal>
            )}

            {(updateOn == true || byosOn == true) && <BYOS
                updateOn={updateOn}
                setByosOn={setByosOn}
                setUpdateOn={setUpdateOn}
            />}
        </>
    );
}

export default Admin;